import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'snakeCaseToTitle'
})
export class SnakeCaseToTitlePipe implements PipeTransform {
  transform(name: string): string {
    return name.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase()).replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase());
  }
}
